import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import CollapseIcon from '../../../images/collapse copy 6.png'
import ExpandIcon from '../../../images/expand copy 6.png'

class OmsattMatrikkelenhet extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleInvolvert = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var matrikkelenhet = this.props.matrikkelenhet
        var matrikkelnummer = `${matrikkelenhet.gardsnummer}/${matrikkelenhet.bruksnummer}`;
        if (matrikkelenhet.festenummer || matrikkelenhet.seksjonsnummer) matrikkelnummer += `/${matrikkelenhet.festenummer}/${matrikkelenhet.seksjonsnummer}`;

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleInvolvert}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{matrikkelenhet.kommuneId}-{matrikkelnummer}</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{matrikkelenhet.kommunenavn} ({matrikkelenhet.kommuneId})</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('matrikkelnummer')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(OmsattMatrikkelenhet)